import {

    Box, Button,
    Center,
    Flex,
    FormControl,
    Heading,
    Select
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import MaterialTable from "material-table";
import { createTheme, ThemeProvider } from "@mui/material";
import { useTranslation } from "react-i18next";
import _find from "lodash/find";
import addressData from "../../data/address.json";
import DistictData from "../../data/District.json";
import LocalLevelData from "../../data/localLevelData.json";
import LocalLevelDataNepali from "../../data/localLevelDataNe.json";
import _filter from "lodash/filter";

import { Roles } from "../../interfaes/user";
import { onGetUsers } from "../../http/users";
import { DisabilityType } from "../../interfaes/student";
import { useNavigate } from "react-router-dom";



import ModernLoader from "../../components/ModernLoader";

export default function StudentDashboard() {
    const [loading, setLoading] = useState(true);
    const [localLevel, setLocalLevel] = useState(0);
    const { t, i18n } = useTranslation();
    const [data, setData] = useState([]);
    const [district, setDistrict] = useState(0);
    const [provience, setProvience] = useState('');
    const [iep] = useState('');
    const [minisupality, setMinisupality] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [serviceArea, setServiceArea] = useState('');
    const [year, setYear] = useState('');
    const [teacherID, setTeacherID] = useState('');
    const [disabilityType, setDisabilityType] = useState('');
    const [disabilityID, setDisabilityID] = useState('');
    const [teachers, setTeachers] = useState([]);
    const districts = DistictData;
    const localLevelData = i18n.language === 'en' ? LocalLevelData : LocalLevelDataNepali;
    const isFilterAllowed = !window.location.pathname.includes('iep-student');

    useEffect(() => {
        getUsers();

        const params = new URLSearchParams(window.location.search);
        onGetDashBoardData(
            params.get('province') || '',
            params.get('district') || '',
            params.get('municipality') || '',
            params.get('serviceArea') || '',
            params.get('teacherId') || '',
            params.get('disabilityType') || '',
            params.get('disabilitySeverity') || '',
            params.get('iep') || '',
            params.get('year') || ''
        );
    }, [window.location.search])

    const getUsers = async () => {
        try {
            const response = await onGetUsers();
            const teacher = response.data.userResponseList.filter((e) => {
                return e?.roles?.includes(Roles.TEACHER)
            })

            setTeachers(teacher);

        } catch (e) {
            console.log(e);
        }
    }
    const disabilityTypeArray = Object.entries(DisabilityType);
    const navigate = useNavigate();

    const columns = !isFilterAllowed ? [
        { title: t('studentLocal:name'), field: 'nameOfChild', type: 'string' },
        { title: 'studentId', field: 'studentId', type: 'string', hidden: true },
        { title: t('users:TEACHER'), field: 'teacherName', type: 'string' },
        { title: t('studentLocal:manageStudents.school'), field: 'schoolName', type: 'string' },
        {
            title: 'Created Date', field: 'dateOfIEP', render: rowData => (
                <div style={{ display: 'flex', alignItems: 'center' }}>


                    {new Date(rowData.dateOfIEP).toDateString()}
                </div>
            )
        },
        { title: t('newLocal:year'), field: 'year', type: 'string' },
    ] : [
        { title: 'studentId', field: 'studentId', type: 'string', hidden: true },
        { title: t('studentLocal:name'), field: 'nameOfChild', type: 'string' },
        { title: t('studentLocal:gender'), field: 'genderOfChild', type: 'string' },
        { title: t('studentLocal:manageStudents.contact'), field: 'contact', type: 'string' },
        { title: t('studentLocal:manageStudents.serviceArea'), field: 'serviceArea', type: 'string' },
        { title: t('studentLocal:manageStudents.school'), field: 'schoolName', type: 'string' },
        { title: t('users:TEACHER'), field: 'teacherName', type: 'string' },
        { title: t('studentLocal:manageStudents.province'), field: 'province', type: 'province' },
        { title: t('studentLocal:manageStudents.district'), field: 'district', type: 'province' },
        { title: t('studentLocal:manageStudents.address'), field: 'municipality', type: 'province' },
        { title: t('studentLocal:manageStudents.Disability'), field: 'disability', type: 'string' },
        { title: t('studentLocal:manageStudents.disabilityType'), field: 'disabilityType', type: 'string' },
        { title: t('studentLocal:manageStudents.disabilityId'), field: 'disabilitySeverity', type: 'string' },
        {
            title: t('newLocal:dateOfIEP'), field: 'dateOfIEP', render: rowData => (
                <div style={{ display: 'flex', alignItems: 'center' }}>


                    {new Date(rowData.dateOfIEP).toDateString()}
                </div>
            )
        },
        { title: t('newLocal:year'), field: 'year', type: 'string' },
        { title: t('newLocal:numberOfGoals'), field: 'numberOfGoals', type: 'string' },
        { title: t('newLocal:numberOfObjectives'), field: 'numberOfObjectives', type: 'string' },
        { title: t('newLocal:numberOfObjectivesAchieved'), field: 'numberOfObjectivesAchieved', type: 'string' },
    ];
    const defaultMaterialTheme = createTheme();
    const onGetDashBoardData = (p, d, m, sa, t, dt, di, iep, year) => {
        setLoading(true);
        axios.post('/dashboard/student-progress', {
            "province": p,
            "district": d,
            "municipality": m,
            "teacherId": t,
            "disabilityType": dt,
            "disabilitySeverity": di,
            "serviceArea": sa,
            "iep": iep,
            "year": year
        }).then((res) => {
            setData(res.data.data);
            setLoading(false);
        }).catch((err) => {
            console.log(err);
            setLoading(false);
        });
    }

    const address = addressData;


    return (
        <Box>
            <Flex justifyContent="space-between" alignItems="center" mb={6}>
                <Heading size="lg">{t('studentLocal:studentList')}</Heading>
                <Flex gap={2}>
                    <Button
                        size="sm"
                        colorScheme="blue"
                        variant="ghost"
                        isLoading={loading}
                        onClick={() => {
                            setLoading(true);
                            axios.post('/dashboard/refresh').then(() => {
                                const params = new URLSearchParams(window.location.search);
                                onGetDashBoardData(
                                    params.get('province') || '',
                                    params.get('district') || '',
                                    params.get('municipality') || '',
                                    params.get('serviceArea') || '',
                                    params.get('teacherId') || '',
                                    params.get('disabilityType') || '',
                                    params.get('disabilitySeverity') || '',
                                    params.get('iep') || '',
                                    params.get('year') || ''
                                );
                            });
                        }}
                    >
                        Refresh
                    </Button>
                    <Button
                        colorScheme="blue"
                        variant="outline"
                        size="sm"
                        onClick={() => navigate(isFilterAllowed ? '/dashboard-student-progress' : '/iep-report-filter')}
                    >
                        Change Filters
                    </Button>
                </Flex>
            </Flex>

            <Box mt={4}>
                <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                        title=""
                        columns={columns}
                        data={data}
                        isLoading={loading}
                        options={{
                            exportButton: {
                                csv: true,
                            },
                            search: true,
                            sorting: true,
                            actionsColumnIndex: -1,
                            pageSize: 20,
                            paginationPosition: 'both'
                        }}
                        components={{
                            OverlayLoading: (props) => (
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    zIndex={100}
                                    bg="whiteAlpha.700"
                                    display={loading ? "flex" : "none"}
                                    alignItems="flex-start"
                                    justifyContent="center"
                                    pt="80px"
                                >
                                    <ModernLoader h="150px" message="Fetching student data..." />
                                </Box>
                            )
                        }}
                        onRowClick={(row, rowData) => {
                            navigate('/students-profile/' + rowData.studentId)
                        }}
                    />
                </ThemeProvider>
            </Box>
        </Box>
    );
}
